import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationThresholdComponent, TreatmentProgressBarComponent } from '../../plan';
import { PublishService } from '../../services';
import { BaseComponent, PublishedPlansProgressComponent } from '../../shared';


/**
 * Component for plan settings tab of publish page.
 */
@Component({
	selector: 'tsp-publish-plan',
	imports: [
		FormsModule,
		TreatmentProgressBarComponent,
		NotificationThresholdComponent,
		PublishedPlansProgressComponent
	],
	templateUrl: './publish-plan.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PublishPlanComponent extends BaseComponent {

	private readonly pubSrv = inject(PublishService);

	treatmentProgress = this.pubSrv.treatmentProgress;
	consolidationDays = this.pubSrv.consolidationDays;
	isConsolidationValid = this.pubSrv.isConsolidationValid;
	threshold = this.pubSrv.threshold;
	publishedPlans = this.pubSrv.publishedPlans;


	/**
	 * Update Consolidation Days.
	 */
	updateConsolidationDays(val?: number): void {
		this.consolidationDays.set(val);
		if (val) (this.treatmentProgress()!.consolidationDays = val);
	}

}
